import React, { createContext, useCallback, useEffect, useState } from "react";
import type { IpLocation } from "../lib/ipLocation/providers";
import { fetchIpLocation, clearIpLocationCache } from "../lib/ipLocation/providers";

export type ContextValue = {
    data: IpLocation | null;
    loading: boolean;
    refresh: () => Promise<void>;
};

const IpLocationContext = createContext<ContextValue | undefined>(undefined);

export const IpLocationProvider = ({ children }: { children: React.ReactNode }) => {
    const [data, setData] = useState<IpLocation | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const resolve = useCallback(async () => {
        setLoading(true);
        try {
            const res = await fetchIpLocation();
            setData(res);
            // Log localidad una sola vez cuando haya data y no error
            if (!res.error) {
                const locality = res.city || res.region || res.country || "Desconocida";
                console.info("Localidad:", locality);
            }
        } catch (err) {
            setData({ error: "No se pudo obtener ubicación" });
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        let mounted = true;
        (async () => {
            if (!mounted) return;
            await resolve();
        })();
        return () => {
            mounted = false;
        };
    }, [resolve]);

    const refresh = useCallback(async () => {
        clearIpLocationCache();
        await resolve();
    }, [resolve]);

    const value: ContextValue = { data, loading, refresh };

    return <IpLocationContext.Provider value={value}>{children}</IpLocationContext.Provider>;
};

export default IpLocationContext;
